import { Text } from "@chakra-ui/react";

type AsteriskProps = {
  color?: string;
};

const Asterisk = ({ color }: AsteriskProps) => {
  return (
    <Text fontSize={"lg"} as="span" color={color ? color : "status.error"}>
      *
    </Text>
  );
};

export default Asterisk;
